import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toggleModal } from "../../../reducers/modalReducer";

const ModuleCardHeader = ({ resolvedLogo, logoAlt, subTitle, name, moduleSlug, company, subscriptionLabel, setTab, isPaid, hasPurchased, isRestricted, onRequirePurchase, onRestrictedClick, externalUrl, isResearchAid, isNavigationModule }) => {
    const dispatch = useDispatch();
    return (
        <div className='df aic jcsb w100'>
            <div className='df aic w100' style={{ overflow: 'hidden' }}>
                <div
                    className='br10px bg1 p0-5rem df aic jcc'
                    style={{ width: '60px', height: '60px', border: '1px solid #E3E3E3', flexShrink: 0 }}
                >
                    <img src={resolvedLogo} alt={logoAlt} width={52} height={47} />
                </div>
                <div className='df fdc pr w100'>
                    {subTitle
                        ? <p className='fs12px fw400 c15 op70 pa' style={{ left: '1rem', top: '-14px' }}>{subTitle}</p>
                        : null
                    }
                    <div className='df aic jcsb w100'>
                        <Link
                            to={isRestricted ? '#' : (isNavigationModule && isResearchAid && externalUrl === '#') ? '' : (isNavigationModule && isResearchAid) ? `/researchAid/${company?.['_id']}?${externalUrl}` : (externalUrl ? '#' : `#${moduleSlug}`)}
                            onClick={(e) => {
                                if (isRestricted) {
                                    e.preventDefault();
                                    onRestrictedClick && onRestrictedClick();
                                    return;
                                }
                                if (externalUrl && !isResearchAid) {
                                    e.preventDefault();
                                    window.open(externalUrl, '_blank', 'noopener,noreferrer');
                                    return;
                                }
                                if (isPaid && !hasPurchased) {
                                    e.preventDefault();
                                    onRequirePurchase && onRequirePurchase();
                                    return;
                                }
                                if (isNavigationModule && isResearchAid && externalUrl === '#') {
                                    e.preventDefault();
                                    dispatch(toggleModal({ open: 'swotReportPopup' }));
                                    return;
                                }
                                setTab(moduleSlug);
                            }}
                            className='fs15px fw500 c15 ml1rem'
                            style={{ overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', marginTop: '0px', lineHeight: '1.2' }}
                        >
                            {name}
                        </Link>
                        {subscriptionLabel && (
                            <span
                                className='fs14px fw600 ml0-5rem'
                                style={{ color: '#4CAF50', flexShrink: 0, letterSpacing: '0.03em' }}
                            >
                                {subscriptionLabel}
                            </span>
                        )}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ModuleCardHeader;
